module.exports = __webpack_public_path__ + "01_short_grey.f94a8ab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_short_grey.png
// module id = NryA
// module chunks = 0